module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Wind-2020c75c828781b121501b38bcdf981f.svg";